import axios from 'axios';
import axiosRetry, { isRetryableError } from 'axios-retry';

const DEFAULT_RETRY_AMOUNT = 2;
const DEFAULT_RETRY_DELAY = () => 2 * 1000;
const DEFAULT_RETRY_CLAUSE = error => {
  if (!error.config) {
    return false;
  }

  return (
    isRetryableError(error) &&
    ['get', 'head', 'options'].indexOf(error.config.method) !== -1
  );
};

export const axiosInstance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosRetry(axiosInstance, {
  retries: DEFAULT_RETRY_AMOUNT,
  retryDelay: DEFAULT_RETRY_DELAY,
  retryCondition: DEFAULT_RETRY_CLAUSE,
});

export default {};
